import React from 'react';
import {observer} from 'mobx-react-lite';
import {Wrapper, NumberStep, StepperLine} from '../style';

const Stepper = ({activeRegistrationStep}: Props) => {
  return (
    <Wrapper>
      <div className="d-flex align-items-center justify-content-between w-100">
        <NumberStep status>
          <span>1</span>
        </NumberStep>
        <StepperLine status={['account', 'payment'].includes(activeRegistrationStep)} />
        <NumberStep status={['account', 'payment'].includes(activeRegistrationStep)}>
          <span>2</span>
        </NumberStep>
        <StepperLine status={activeRegistrationStep === 'payment'} />
        <NumberStep status={activeRegistrationStep === 'payment'}>
          <span>3</span>
        </NumberStep>
      </div>
    </Wrapper>
  );
};

export default observer(Stepper);
